<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-sm-12 text-center">
        <h2>Create Motor Offer</h2>
        <button type="button" class="btn btn-primary" @click="Auth0">Auth0</button>
        <input type="text" v-model="OTP" />
        <button type="button" class="btn btn-primary" @click="validateOTP">Validate</button>
      </div>
      <div class="col-lg-8">
        <motor-vehicle-details v-if="motor.data && STEP === 1" :data="data" :lovs="lovs" @next="next" />
        <motor-owner-details v-if="motor.data && STEP === 2" :data="data" :lovs="lovs" @next="next" @previous="previous" />
        <motor-package-selection v-if="motor.data && STEP === 3" :data="data" :lovs="lovs" @next="next" @previous="previous" />
        <motor-optional-cover v-if="motor.data && STEP === 4" :data="data" :lovs="lovs" @next="next" @previous="previous" />
        <motor-plan-selection v-if="motor.data && STEP === 5" :data="data" :lovs="lovs" @submit="submit" @previous="previous" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import messages from '@/shared/modules/notifications';
// import auth from 'auth0-js';
import axios from 'axios';
import MotorVehicleDetails from './ComponentsMotor/MotorVehicleDetails.vue';
import MotorOwnerDetails from './ComponentsMotor/MotorOwnerDetails.vue';
import MotorPackageSelection from './ComponentsMotor/MotorPackageSelection.vue';
import MotorOptionalCover from './ComponentsMotor/MotorOptionalCovers.vue';
import MotorPlanSelection from './ComponentsMotor/MotorPlanSelection.vue';

export default {

  components: {
    MotorVehicleDetails,
    MotorOwnerDetails,
    MotorPackageSelection,
    MotorOptionalCover,
    MotorPlanSelection
  },
  data() {
    return {
      STEP: 1,
      OTP: null,
      webAuth: null
    };
  },
  computed: {
    ...mapState({
      motor: (state) => state.motor.motor
    }),
    data() {
      return JSON.parse(JSON.stringify(this.motor.data));
    },
    lovs() {
      return JSON.parse(JSON.stringify(this.motor.lovs));
    },
  },
  async created() {
    // console.log(this.$gtag);
    await this.loadMotorData();
  },
  methods: {
    ...mapActions('motor', ['getMotorDataAction', 'updateValue']),
    ...mapActions('offer', ['addOfferAction']),
    async loadMotorData() {
      await this.getMotorDataAction({ offer: this.$route.params.id });
    },
    async submit() {
      await this.addOfferAction(this.data);
      messages({ type: 'success', message: 'New offer Added to cart!' });
      this.$router.push({ name: 'HomePage' });
    },
    next() {
      this.updateValue({ path: 'motor.data', value: this.data });
      this.STEP++;
    },
    previous() {
      this.STEP--;
    },
    async Auth0() {
      const response = await axios.post('https://improvittg.eu.auth0.com/passwordless/start', {
        client_id: 'cjoxXNhCQjNl91J6H8k0D6Z7YsxyF5b3',
        client_secret: 'G-NUSuC00KENmgEeLSrtpNSHuF6VE_xJ8dSnxfAq7TK72uT_bBxzwF5U2-7wVXAL', // For Regular Web Applications
        connection: 'email',
        email: 'agkoumas@improvit.gr', // set for connection=email
        send: 'code' // if left null defaults to link
      });
      console.log(response);
      /* this.webAuth = new auth.WebAuth({
        domain: 'improvittg.eu.auth0.com',
        clientID: 'cjoxXNhCQjNl91J6H8k0D6Z7YsxyF5b3',
        responseType: 'token',
        // redirectUri: 'http://example.com'
      });
      console.log(this.webAuth);
      this.webAuth.passwordlessStart({
        connection: 'email',
        send: 'code',
        email: 'agkoumas@improvit.gr'
      }, (err, res) => {
        console.log('err', err);
        console.log('res', res);
        // handle errors or continue
      }); */
    },
    async validateOTP() {
      const response = await axios.post('https://improvittg.eu.auth0.com/oauth/token', {
        headers: {
          'Content-Type': 'application/json'
        },
        grant_type: 'http://auth0.com/oauth/grant-type/passwordless/otp',
        client_id: 'cjoxXNhCQjNl91J6H8k0D6Z7YsxyF5b3',
        client_secret: 'G-NUSuC00KENmgEeLSrtpNSHuF6VE_xJ8dSnxfAq7TK72uT_bBxzwF5U2-7wVXAL', // only for web apps, native apps don’t have a client secret
        username: 'agkoumas@improvit.gr', // or "<phone number>"
        otp: this.OTP,
        realm: 'email', // or "sms"
        scope: 'openid profile email' // whatever scopes you need
      });
      console.log(response);
      // const webAuth = new auth.WebAuth({
      //   domain: 'improvittg.eu.auth0.com',
      //   clientID: 'cjoxXNhCQjNl91J6H8k0D6Z7YsxyF5b3',
      //   responseType: 'token',
      //   // redirectUri: 'http://localhost:8080/motor'
      // });
      // this.webAuth.passwordlessVerify({
      //   connection: 'email',
      //   email: 'agkoumas@improvit.gr',
      //   verificationCode: this.OTP
      // }, (err, res) => {
      //   console.log('err', err);
      //   console.log('res', res);
      //   // handle errors or continue
      // });
    }
  }
};
</script>
